Object.defineProperty(exports, "__esModule", { value: true });
var ToMap = /** @class */ (function () {
    function ToMap() {
    }
    /**
     * Returns a map consisting of each key-value pair. If a `map` is passed
     * the pairs are set on this map. Duplicate keys override each other.
     *
     * @param {Map<K, V>} map
     * @returns {Map<K, V>}
     */
    ToMap.prototype.toMap = function (map) {
        var result = map || new Map();
        for (var item = this.iterator.next(); !item.done; item = this.iterator.next()) {
            var pair = item.value;
            var key = pair[0];
            var value = pair[1];
            result.set(key, value);
        }
        return result;
    };
    return ToMap;
}());
exports.ToMap = ToMap;
//# sourceMappingURL=toMap.js.map